import React from "react";
import AutomationHistoryIcon from "../../../travelerProfile/components/icons/AutomationHistoryIcon";
//import FlexApi from "twilio/lib/rest/FlexApi";

const CustomNoDataComponent = () => {
    return (
        <div style={{ 
                textAlign: 'center', 
                padding: '40px 0', 
                display:"flex",  
                flexDirection:"column",
                justifyContent:"center",
                alignItems:"center",
                gap:"10px"
            }}
        >
            <AutomationHistoryIcon />
            <div style={{
                color: '#373737',
                textAlign: 'center',
                fontFamily: 'Nunito, sans-serif',
                fontSize: 18,
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '120%',
                letterSpacing: '0.018px'
            }}>
                No Automation Activity Yet
            </div>
            <div style={{
                color: '#373737',
                textAlign: 'center',
                fontFamily: '"Open Sans", sans-serif',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '120%',
                letterSpacing: '0.035px'
            }}>
                This automation hasn’t run yet. Once it’s triggered, activity will appear here.
            </div>
        </div>
    )
}

export default CustomNoDataComponent;